import { useState } from 'react';
import { Page } from 'react-pdf';
import { useElementSize } from '@custom-react-hooks/use-element-size';
import { CircularProgress } from '@mui/material';

import { StyledContainer, StyledDocument, StyledLoadingContainer } from './styled';

type PreviewFullPdfViewerProps = {
  link: string;
};
export default function PreviewFullPdfViewer({ link }: PreviewFullPdfViewerProps) {
  const [setRef, size] = useElementSize();
  const [pageCount, setPageCount] = useState(0);

  return (
    <StyledContainer ref={setRef}>
      {link && (
        <StyledDocument
          file={link}
          onLoadSuccess={(pdf) => setPageCount(pdf.numPages)}
          loading={
            <StyledLoadingContainer>
              <CircularProgress />
            </StyledLoadingContainer>
          }
        >
          {new Array(pageCount).fill(0).map((_, i) => (
            <Page key={i} pageIndex={i} width={size.width} height={size.height} />
          ))}
        </StyledDocument>
      )}
    </StyledContainer>
  );
}
